export default __webpack_public_path__ + "static/hero_cloud_front-06c1f7db530ae0084f15248418e69d2c.webp";